module.exports = {
  AFRAME_INJECTED: 'aframe-injected',
  DEFAULT_CAMERA_HEIGHT: 1.6,
  DEFAULT_HANDEDNESS: 'right',
  animation: require('./animation'),
  keyboardevent: require('./keyboardevent')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/aframe/src/constants/index.js
// module id = 66
// module chunks = 0